import {
  ClearOutlined,
  DownOutlined,
  FilterOutlined,
  SearchOutlined,
  UpOutlined,
} from '@ant-design/icons';
import BottomSheet from 'components/UI/Responsive/BottomSheet';
import FilterChips, { FilterChip } from 'components/UI/Responsive/FilterChips';
import { VerticalFormFields } from 'styles/VerticalFormFields';
import { FilterLayoutProps } from './types';

import * as S from './styles';

type Props = FilterLayoutProps & {
  chips: FilterChip[];
  isSheetOpen: boolean;
  onCloseSheet: () => void;
  inlineActions?: boolean;
};

const ADVANCED_ID = 'phone-filters-advanced';

const describeActiveCount = (count: number): string =>
  count === 1 ? '1 ativo' : `${count} ativos`;

export default function PhoneFilters({
  chips,
  isSheetOpen,
  onCloseSheet,
  mainFields,
  advancedFields,
  activeAdvancedCount,
  isAdvancedOpen,
  onToggleAdvanced,
  onClear,
  onSearchAndClose,
  inlineActions = false,
}: Props) {
  const footer = (
    <S.Actions>
      <S.ActionButton type="button" onClick={onClear}>
        Limpar
      </S.ActionButton>
      <S.ActionButton
        type="button"
        data-primary="true"
        onClick={onSearchAndClose}
      >
        Buscar
      </S.ActionButton>
    </S.Actions>
  );

  return (
    <>
      {chips.length > 0 && <FilterChips chips={chips} />}

      <BottomSheet
        isOpen={isSheetOpen}
        onClose={onCloseSheet}
        title="Filtros"
        keepMounted
        footer={inlineActions ? undefined : footer}
      >
        <VerticalFormFields>
          <S.SheetFields data-inline-actions={inlineActions}>
            {mainFields}

            {inlineActions ? (
              <S.InlineActions>
                <S.ActionButton
                  type="button"
                  aria-expanded={isAdvancedOpen}
                  aria-controls={ADVANCED_ID}
                  onClick={onToggleAdvanced}
                >
                  <FilterOutlined aria-hidden />
                  Avançados
                  {activeAdvancedCount > 0 && ` (${activeAdvancedCount})`}
                </S.ActionButton>
                <S.ActionButton type="button" onClick={onClear}>
                  <ClearOutlined aria-hidden />
                  Limpar
                </S.ActionButton>
                <S.ActionButton
                  type="button"
                  data-primary="true"
                  onClick={onSearchAndClose}
                >
                  <SearchOutlined aria-hidden />
                  Buscar
                </S.ActionButton>
              </S.InlineActions>
            ) : (
              <S.AdvancedToggle
                type="button"
                aria-expanded={isAdvancedOpen}
                aria-controls={ADVANCED_ID}
                onClick={onToggleAdvanced}
              >
                Filtros avançados
                <S.ActiveCount>
                  {activeAdvancedCount > 0 &&
                    describeActiveCount(activeAdvancedCount)}
                  {isAdvancedOpen ? (
                    <UpOutlined aria-hidden />
                  ) : (
                    <DownOutlined aria-hidden />
                  )}
                </S.ActiveCount>
              </S.AdvancedToggle>
            )}

            <div id={ADVANCED_ID} hidden={!isAdvancedOpen}>
              {advancedFields}
            </div>
          </S.SheetFields>
        </VerticalFormFields>
      </BottomSheet>
    </>
  );
}
